function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
  
customElements.define('quantity-input', QuantityInput);

class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
      });
    }
}
  
customElements.define('cart-remove-button', CartRemoveButton);

class RFValue extends HTMLElement {
    constructor() {
      super();
      this.recommended_form = this.closest('recommended-form');
      this.rf_options1 = this.recommended_form.querySelector('rf-options[data-option1]');
      this.rf_options2 = this.recommended_form.querySelector('rf-options[data-option2]');
      this.rf_options3 = this.recommended_form.querySelector('rf-options[data-option3]');
      this.idInput = this.recommended_form.querySelector('input[name="id"]');
      this.submitBtn = this.recommended_form.querySelector('.cart-drawer__recommended-list-item-atc');
      this.imageNode = this.closest('.cart-drawer__recommended-list-item-inner').querySelector('.cart-drawer__item-image');
      this.priceNode = this.closest('.cart-drawer__recommended-list-item-inner').querySelector('.cart-drawer__recommended-list-item-price');

      this.addEventListener('click', this.handleVariantChange.bind(this));
    }

    handleVariantChange() {
        this.updateHTML();

        var option1 = this.rf_options1 && this.rf_options1 !== null ? this.rf_options1.getAttribute('data-option1') : null;
        var option2 = this.rf_options2 && this.rf_options2 !== null ? this.rf_options2.getAttribute('data-option2') : null;
        var option3 = this.rf_options3 && this.rf_options3 !== null ? this.rf_options3.getAttribute('data-option3') : null;

        var variants = JSON.parse(this.closest('recommended-form').querySelector('.product-object').innerHTML);

        var current_variant = variants.filter((v) => {
            return v.option1 === option1 && v.option2 === option2 && v.option3 === option3
        })[0];

        if (current_variant && current_variant !== undefined) {
            this.updateID(current_variant);
            this.updateImage(current_variant);
            this.updatePrice(current_variant);
            this.updateAvailability(current_variant);
        }
    }

    updateAvailability(current_variant) {
        if (current_variant.available === false) {
            this.submitBtn.disabled = true;
        } else {
            this.submitBtn.disabled = false;
        }
    }

    updatePrice(current_variant) {
        var price = Shopify.formatMoney(current_variant.price, '');
        this.priceNode.innerHTML = price;
    }

    updateImage(current_variant) {
        var image_url = current_variant.featured_image.src;
        if (image_url && image_url !== undefined) {
            this.imageNode.src = image_url;
        }
    }

    updateID(current_variant) {
        this.idInput.value = current_variant.id;
    }

    updateHTML() {
        var container = this.closest('rf-options');
        var valueNode = container.querySelector('.cart-drawer__selected-value');
        var index = this.getAttribute('data-index');
        var value = this.getAttribute('data-value');
        valueNode.innerHTML = this.innerHTML;
        container.setAttribute('data-option' + index, value);
    }
}
  
customElements.define('rf-value', RFValue);

class RFOptions extends HTMLElement {
    constructor() {
      super();
      this.btnToggle = this.querySelector('.cart-drawer__recommended-form-toggle');
      this.dropdown = this.querySelector('.cart-drawer__recommended-form-values');
      this.btnToggle.addEventListener('click', this.toggleVariantsDropdown.bind(this));
      document.body.addEventListener('click', this.closeHandler.bind(this));
    }

    closeHandler() {
        if (!event.target.closest('rf-options')) {
            this.dropdown.classList.add('hide');
        }
    }

    toggleVariantsDropdown() {
        event.preventDefault();
        if (this.dropdown.classList.contains('hide')) {
            this.dropdown.classList.remove('hide');
        } else {
            this.dropdown.classList.add('hide');
        }
    }
}
  
customElements.define('rf-options', RFOptions);

class RecommendedForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.errorContainer = this.form.querySelector('[data-error-container]');
  }

  openCartDrawer() {
    document.getElementById('cart-drawer').classList.add('open');
    document.getElementById('site-wrapper').classList.add('overflow-hidden');
  }

  updateKlarnaMessage() {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }

  updateRecommendations() {
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;

                var recs_in_cart = document.querySelectorAll('.cart-drawer__recommended-list-item-in-cart');
                if (recs_in_cart && recs_in_cart !== null) {
                    recs_in_cart.forEach(rec_in_cart => {
                        rec_in_cart.remove();
                    });
                }

                var recommended_slider_selector = '#cart-drawer__recommended-slider';
                new Swiper(recommended_slider_selector, {
                    navigation: {
                        nextEl: '#cart-drawer__recommended-slider-nav-item-next',
                        prevEl: '#cart-drawer__recommended-slider-nav-item-prev'
                    },
                    slidesPerView: 1,
                    spaceBetween: 10
                })
            }
        })
        .catch(e => {
            console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
  }

  updateCartBubble() {
    $.getJSON('/cart.js', function(cart) {
      var counter = document.querySelector('[data-cart-bubble] .cart-counter');
      var counter_mobile = document.querySelector('.mobile-menu-item .cart-counter');
      if (counter && counter !== undefined) {
        counter.innerHTML = cart.item_count;
      } else {
        var cart_counter_html = document.createElement('span');
        cart_counter_html.classList.add('cart-counter');
        cart_counter_html.innerHTML = cart.item_count;
        document.querySelector('[data-cart-bubble]').append(cart_counter_html);
      }

      if (!counter_mobile) {
        return;
      }
      counter_mobile.innerHTML = '(' + cart.item_count + ')';
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.errorContainer) {
      this.errorContainer.style.display = 'none'
      this.errorContainer.innerHTML = ''
    }

    const form = this.form;
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      ...JSON.parse(serializeForm(form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.log('Recommended product adding to cart failed', response.status) 
          if (this.errorContainer) {
            this.errorContainer.style.display = 'block'
            this.errorContainer.innerHTML = response.description
          }
          return;
        }

        this.updateCartBubble();

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(response.sections[section.section], section.selector);
        }));

        this.updateKlarnaMessage();
        this.openCartDrawer();
        this.updateRecommendations();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {

      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-cart-drawer__itemsWrapper',
      },
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-cart-drawer__free-shipping'
      },
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-cart-drawer__total'
      },
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-recommended-products'
      },
      {
        id: 'cart-drawer',
        section: document.getElementById('cart-drawer').dataset.id,
        selector: '.js-cart-drawer__klarna'
      }
    ];
  }

  onGiftCartAdd() {

  }
}

customElements.define('recommended-form', RecommendedForm);

class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.addEventListener(
        'click',
        this.cartDrawerClickHandler.bind(this)
      );

      this.querySelector('.cart-drawer__close').addEventListener(
        'click',
        this.close.bind(this)
      );

      document.querySelector('[data-open-cart-drawer]').addEventListener(
        'click',
        this.cartIconClickHandler.bind(this)
      );

      document.addEventListener('gcp-item-added', this.gcpItemAddedHandler.bind(this));

      document.querySelector('.mobile-cart-toggler')?.addEventListener(
        'click',
        this.cartIconClickHandler.bind(this)
      );
    }

    updateCartBubble() {
      $.getJSON('/cart.js', function(cart) {
        var counter = document.querySelector('[data-cart-bubble] .cart-counter');
        var counter_mobile = document.querySelector('.mobile-menu-item .cart-counter');
        if (counter && counter !== undefined) {
          counter.innerHTML = cart.item_count;
        } else {
          var cart_counter_html = document.createElement('span');
          cart_counter_html.classList.add('cart-counter');
          cart_counter_html.innerHTML = cart.item_count;
          document.querySelector('[data-cart-bubble]').append(cart_counter_html);
        }
        if (!counter_mobile) {
          return;
        }
        counter_mobile.innerHTML = '(' + cart.item_count + ')';
      });
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          section: document.getElementById('cart-drawer').dataset.id,
          selector: '.js-cart-drawer__itemsWrapper',
        },
        {
          id: 'cart-drawer',
          section: document.getElementById('cart-drawer').dataset.id,
          selector: '.js-cart-drawer__free-shipping'
        },
        {
          id: 'cart-drawer',
          section: document.getElementById('cart-drawer').dataset.id,
          selector: '.js-cart-drawer__total'
        },
        {
          id: 'cart-drawer',
          section: document.getElementById('cart-drawer').dataset.id,
          selector: '.js-recommended-products'
        },
        {
          id: 'cart-drawer',
          section: document.getElementById('cart-drawer').dataset.id,
          selector: '.js-cart-drawer__klarna'
        }
      ];
    }

    updateKlarnaMessage() {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    updateRecommendations() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
    
            observer.unobserve(productRecommendationsSection);
    
            const url = productRecommendationsSection.dataset.url;
    
            fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');
    
                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;

                    var recs_in_cart = document.querySelectorAll('.cart-drawer__recommended-list-item-in-cart');
                    if (recs_in_cart && recs_in_cart !== null) {
                        recs_in_cart.forEach(rec_in_cart => {
                            rec_in_cart.remove();
                        });
                    }
    
                    var recommended_slider_selector = '#cart-drawer__recommended-slider';
                    new Swiper(recommended_slider_selector, {
                        navigation: {
                            nextEl: '#cart-drawer__recommended-slider-nav-item-next',
                            prevEl: '#cart-drawer__recommended-slider-nav-item-prev'
                        },
                        slidesPerView: 1,
                        spaceBetween: 10
                    })
                }
            })
            .catch(e => {
                console.error(e);
            });
        };
    
        const productRecommendationsSection = document.querySelector('.product-recommendations');
        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    
        observer.observe(productRecommendationsSection);
    }

    updateQuantity(line, quantity, name) {
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);

          this.updateCartBubble();
  
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateRecommendations();
          this.updateKlarnaMessage();
          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        }).catch(() => {
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        });
    }

    updateLiveRegions(line, itemCount) {
      if (this.currentItemCount === itemCount) {
        document.getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
  
      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);
  
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    open() {
      this.classList.add('open');
      document.getElementById('site-wrapper').classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('open');
      document.getElementById('site-wrapper').classList.remove('overflow-hidden');
    }

    cartDrawerClickHandler(event) {
      if (!event.target.closest('.cart-drawer__main')) {
          this.close();
      }
    }

    cartIconClickHandler(event) {
      event.preventDefault();
      this.open();
    }

    gcpItemAddedHandler(event) {
        event.preventDefault();

        fetch(`/?sections=${[...new Set(this.getSectionsToRender().map((section) => section.id))]}`).then((response) => {
            return response.text();
        }).then((state) => {
            const parsedState = JSON.parse(state);

            this.getSectionsToRender().forEach((section => {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                if (!elementToReplace) {
                    return;
                }

                const html = this.getSectionInnerHTML(parsedState[section.section], section.selector);
                if (!html) {
                    return;
                }

                elementToReplace.innerHTML = html;
            }));

            this.updateRecommendations();
            this.updateKlarnaMessage();
            this.updateCartBubble();
            this.open();

            window.GCPSDK.form.set('id', '1668533162628');
            window.GCPSDK.form.set('fields._gcp_helper_tabIndex', 0);
            window.GCPSDK.form.set('properties._gcp_selected_card_image', undefined);
            window.GCPSDK.form.set('properties._gcp_send_to_self', false);
            window.GCPSDK.form.set('properties._gcp_recipient_email', "");
            window.GCPSDK.form.set('properties._gcp_recipient_phone', "");
            window.GCPSDK.form.set('properties._gcp_recipient_name', "");
            window.GCPSDK.form.set('properties._gcp_message_from', "");
            window.GCPSDK.form.set('properties._gcp_message_text', "");
            window.GCPSDK.form.set('properties._gcp_delivery_time', "Send Now");
            window.GCPSDK.form.set('properties._gcp_video_url', "");
            window.GCPSDK.form.set('properties._gcp_thumbnail_url', "");

            const breadcrumb = document.querySelector(".gc__breadcrumb_button");
            if (!breadcrumb) {
                return;
            }

            breadcrumb.click();
        }).catch(() => {
            document.getElementById('cart-errors').textContent = window.cartStrings.error;
        });
    }
}

customElements.define('cart-drawer', CartDrawer);